import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../utils/api";
import Navbar from "../components/Navbar";
import { CheckCircle, AlertCircle, Clock } from "lucide-react";

export default function BillingSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const applied = params.get("applied");
  const [state, setState] = useState("checking");
  const [detail, setDetail] = useState("");

  useEffect(() => {
    if (applied) { setState("success"); setDetail("Package activated"); return; }
    if (!sessionId) { setState("error"); setDetail("Missing session"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const res = await api.get(`/billing/checkout/status/${sessionId}`);
        if (res.data.payment_status === "paid") { setState("success"); setDetail("Payment received"); return; }
        if (res.data.status === "expired") { setState("error"); setDetail("Checkout session expired"); return; }
        if (attempts < 6) setTimeout(poll, 2000);
        else { setState("error"); setDetail("Status check timed out. Please check your email or contact support."); }
      } catch (e) {
        setState("error");
        setDetail(e?.response?.data?.detail || "Unable to verify payment");
      }
    };
    poll();
  }, [sessionId, applied]);

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />
      <main className="max-w-xl mx-auto px-6 py-12">
        <div className="bg-white border border-[#E2E8E3] rounded-md p-8 text-center" data-testid="billing-success-page">
          {state === "checking" && <><Clock className="w-12 h-12 text-sage-500 mx-auto mb-3 animate-pulse" /><h2 className="font-heading text-xl font-semibold text-sage-900">Verifying payment…</h2><p className="text-sage-500 text-sm mt-1">This usually takes a few seconds.</p></>}
          {state === "success" && <><CheckCircle className="w-12 h-12 text-green-600 mx-auto mb-3" /><h2 className="font-heading text-xl font-semibold text-sage-900">Thank you!</h2><p className="text-sage-500 text-sm mt-1">{detail}. Your toolbox is ready.</p><Link to="/" className="inline-block mt-5 bg-sage-600 text-white rounded-md px-4 py-2 text-sm font-semibold hover:bg-sage-700">Go to dashboard</Link></>}
          {state === "error" && <><AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-3" /><h2 className="font-heading text-xl font-semibold text-sage-900">Something went wrong</h2><p className="text-sage-500 text-sm mt-1">{detail}</p><Link to="/pricing" className="inline-block mt-5 border border-sage-200 rounded-md px-4 py-2 text-sm font-semibold hover:bg-sage-50">Back to pricing</Link></>}
        </div>
      </main>
    </div>
  );
}
